import {itemOwner} from './group-split';
import type {UndoableState} from '../../vendor/src/features/remotion-editor/editor/state/types';
import type {EditorStarterItem} from '../../vendor/src/features/remotion-editor/editor/items/item-type';
import {readCinematicMotion,validateCinematicMotionDocument,type CinematicMotion} from '../../protocol/cinematic-motion';
export const cinematicMotionEditSignature=(item:EditorStarterItem)=>JSON.stringify([item.cinematicMotion,'assetId' in item?item.assetId:null]);
export function editCinematicMotion(document:UndoableState,itemId:string,expected:string,patch:Partial<CinematicMotion>,characterAssetId?:string):UndoableState{
 const item=document.items[itemId];
 if(!item||(item.type!=='image'&&item.type!=='video')||!item.cinematicMotion||cinematicMotionEditSignature(item)!==expected)throw new Error('그래픽이 바뀌었습니다. 다시 선택해 주세요.');
 if(!itemOwner({undoableState:document},itemId)||itemOwner({undoableState:document},itemId)?.track.locked)throw new Error('트랙 잠금을 해제한 뒤 수정해 주세요.');
 const data=readCinematicMotion(item.cinematicMotion)!;const next={...data,...patch};
 if(next.mode!==data.mode)throw new Error('그래픽 종류는 그대로 유지해 주세요.');
 let updated:EditorStarterItem={...item,cinematicMotion:next};
 if(characterAssetId!==undefined){
  if(data.mode!=='card'||item.type!=='image')throw new Error('M 카드의 인물 이미지만 교체할 수 있습니다.');
  const asset=document.assets[characterAssetId];if(asset?.type!=='image'||!asset.remoteUrl?.startsWith('https://'))throw new Error('보관이 완료된 이미지 원본을 선택해 주세요.');
  next.character=true;next.sourceUrl=asset.remoteUrl;updated={...item,assetId:characterAssetId,cinematicMotion:next};
 }
 readCinematicMotion(next);
 const result:UndoableState={...document,items:{...document.items,[itemId]:{...updated,cinematicMotion:structuredClone(next)}}};
 if(!validateCinematicMotionDocument(result))throw new Error('그래픽과 이미지 원본 연결을 확인해 주세요.');
 return result;
}
